export const withScenarioQuery = (url: string, scenario?: string) => {
  if (!scenario) return url;
  const separator = url.includes("?") ? "&" : "?";
  return `${url}${separator}scenario=${encodeURIComponent(scenario)}`;
};
